import { getQueryString } from "utils/getQueryString";
import axios from "../axios";

export const get = (companyId) => axios.get(`/companies/${companyId}`);

export const getHistoryCompany = (companyId) => {
    return axios.get(`/companies/${companyId}?isDashboard=true`);
};

export const getHistoryCompanyOfficials = (companyId, params) =>
    axios.get(
        `/companies/${companyId}/company-officials?${getQueryString(params)}`
    );

export const getHistoryCompanyBeneficialOwners = (companyId) =>
    axios.get(`/companies/${companyId}/beneficial-owners`);

export const getOfficial = (companyId, officialId, idType, JSGroupID) =>
    axios.get(
        `/companies/${companyId}/officials/${officialId}?idType=${idType}&JSGroupID=${JSGroupID}`
    );

export const getManageCompanyTransactions = (companyId) =>
    axios.get(`/companies/${companyId}/manage-company-transactions`);

const companyDashboardDataService = {
    get,
    getHistoryCompany,
    getHistoryCompanyOfficials,
    getHistoryCompanyBeneficialOwners,
    getOfficial,
    getManageCompanyTransactions,
};

export default companyDashboardDataService;
